import type { Routes } from '@angular/router';
import { AppRoutes } from './app.route.constants';
import { editableNoticeResolver } from './features/create-notice/editable-notice.resolver';
import { unsavedNoticeGuard } from './features/create-notice/unsaved-notice.guard';
import { FEATURE_PATHS } from './layout/nav.config';

export const routes: Routes = [
  {
    path: AppRoutes.ROOT,
    loadComponent: () => import('./layout/shell/shell').then((m) => m.Shell),
    children: [
      { path: AppRoutes.ROOT, pathMatch: 'full', redirectTo: AppRoutes.HOME },
      {
        path: AppRoutes.HOME,
        loadComponent: () => import('./features/home/home').then((m) => m.Home),
      },
      {
        path: AppRoutes.SETTINGS,
        loadComponent: () => import('./features/settings/settings').then((m) => m.Settings),
      },
      {
        path: AppRoutes.CREATE_NOTICE,
        canDeactivate: [unsavedNoticeGuard],
        loadComponent: () =>
          import('./features/create-notice/create-notice').then((m) => m.CreateNotice),
      },
      {
        path: `${AppRoutes.MODIFY_NOTICE}/:id`,
        canDeactivate: [unsavedNoticeGuard],
        resolve: { notice: editableNoticeResolver },
        loadComponent: () =>
          import('./features/create-notice/create-notice').then((m) => m.CreateNotice),
      },
      {
        path: AppRoutes.VALIDATE_NOTICE,
        loadComponent: () =>
          import('./features/validate-notice/validate-notice').then((m) => m.ValidateNotice),
      },
      {
        path: AppRoutes.MY_NOTICES,
        loadComponent: () => import('./features/my-notices/my-notices').then((m) => m.MyNotices),
      },
      {
        path: AppRoutes.HISTORY,
        loadComponent: () => import('./features/history/history').then((m) => m.History),
      },
      ...FEATURE_PATHS.map((path) => ({
        path,
        loadComponent: () =>
          import('./features/placeholder/feature-placeholder').then((m) => m.FeaturePlaceholder),
      })),
      {
        path: AppRoutes.NOT_FOUND,
        loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
      },
    ],
  },
];
